class IdpBadgesGenerator {
    constructor() {

    }
    generateBadge(idps = null) {
        let html = '';
        if(idps == null || idps.length === 0){
            return `<span class="symbol-badge idp-badge badge badge-circle start-85 top-85 w-15px h-15px pb-0"
                           data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true"
                           data-bs-content="<div>Identity: GoodAccess</div>">
                        <div class="img" style="background-image: url('/media/goodaccess/logo/goodaccess-mobile.svg')"></div>      
                     </span>`
        }
        idps.forEach(idp => {
            html += `<span class="symbol-badge idp-badge badge badge-circle start-85 top-85 w-15px h-15px pb-0"
                           data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true"
                           data-bs-content="<div>Identity: ${idp['name']}</div>">
                        <div class="img" style="background-image: url('/vendor/production/avatars/svg/${idp['icon']}.svg')"></div>      
                     </span>`;
        })
        return html;
    }
    generateText(idps = null){
        if(idps == null || idps.length === 0){
            return 'Identity: GoodAccess';
        }

        return idps.map(idp => idp['name']).join(', ');
    }
}
window.IdpBadgesGenerator = IdpBadgesGenerator;